import { render } from "./MessageNotSent.vue?vue&type=template&id=1e76955c&scoped=true"
import script from "./MessageNotSent.vue?vue&type=script&lang=js"
export * from "./MessageNotSent.vue?vue&type=script&lang=js"

import "./MessageNotSent.vue?vue&type=style&index=0&id=1e76955c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e76955c"]])

export default __exports__